import Marquee from "react-fast-marquee";

const ITEMS = [
    "Peinture intérieure",
    "Pose de parquet",
    "Carrelage",
    "Sols vinyles",
    "Façades & finitions",
    "Devis sous 48 h",
];

export default function EditorialMarquee() {
    return (
        <div className="border-y border-linew py-6 bg-coal/60 overflow-hidden" data-testid="editorial-marquee">
            <Marquee
                speed={38}
                gradient={false}
                pauseOnHover={false}
                direction="left"
            >
                <div className="flex items-center whitespace-nowrap">
                    {ITEMS.map((item, i) => (
                        <span key={i} className="flex items-center">
                            <span
                                className={`text-3xl sm:text-4xl uppercase tracking-[0.14em] font-semibold px-8 ${
                                    i % 2 === 0 ? "text-ivory/85" : "text-stroke-gold"
                                }`}
                            >
                                {item}
                            </span>
                            <span className="text-gold text-xl" aria-hidden="true">✦</span>
                        </span>
                    ))}
                </div>
            </Marquee>
        </div>
    );
}
